<div class="ot-flex-header">
    <img src="{{icon}}">
    <p>{{title}}</p>
</div>
<div>
    <p class="ot-alert-messsage">{{message}}</p>
</div>
<div [ngClass]="{'ot-button-divider-error':        type==MessageType.Error,
                'ot-button-divider-question':      type==MessageType.Question,
                'ot-button-divider-warning':       type==MessageType.Warning,
                'ot-button-divider-confirmation':  type==MessageType.Confirmation,
                'ot-button-divider-information':   type==MessageType.Information}">
</div>
<div class="ot-button-wrapper">
    <button *ngIf="txtLeft.length > 0" [mat-dialog-close]="txtLeft"
        [ngClass]="{'ot-alert-secondary-button': txtLeft!=txtPrimary, 'ot-alert-primary-button': txtLeft==txtPrimary}">{{txtLeft}}</button>
    <button *ngIf="txtRight.length > 0" [mat-dialog-close]="txtRight"
        [ngClass]="{'ot-alert-secondary-button': txtRight!=txtPrimary, 'ot-alert-primary-button': txtRight==txtPrimary}">{{txtRight}}</button>
</div>
<div [ngClass]="{'ot-footer-error':        type==MessageType.Error,
                'ot-footer-question':      type==MessageType.Question,
                'ot-footer-warning':       type==MessageType.Warning,
                'ot-footer-confirmation':  type==MessageType.Confirmation,
                'ot-footer-information':   type==MessageType.Information}">
</div>